import EventTreeVertex from "../../EventTreeVertex";
import HCLTreeMxGraph from "../../../../HCLTreeMxGraph/HCLTreeMxGraph";
import {mxConstants, mxGeometry} from "mxgraph-js";

abstract class FunctionalEventPort extends EventTreeVertex {

  /**
   * Basic shape parameters, used and optionally overridden by child classes
   * @type {{RADIUS: number, WIDTH: number, HEIGHT: number, GATE: number}}
   */
  public static SHAPE = {
    HEIGHT: 10,
    WIDTH: 10,
    RADIUS: 5,
    GATE: 0,
  };

  public static SHAPE_KEY = 'func-event-port';

  getMyGeometry(): mxGeometry {
    const g = new mxGeometry(0, 0, FunctionalEventPort.SHAPE.WIDTH, FunctionalEventPort.SHAPE.HEIGHT);
    g.relative = true;
    return g;
  }

  /**
   * @override
   * @return {[index: string]: any}
   */
  getMyStyle(): {[index: string]: any} {
    const style: {[index: string]: any} = {};
    style[mxConstants.STYLE_FILL_OPACITY] = '100';
    style[mxConstants.STYLE_STROKE_OPACITY] = '100';
    style[mxConstants.STYLE_STROKEWIDTH] = '2';
    style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_ELLIPSE;
    style[mxConstants.STYLE_AUTOSIZE] = 1;
    style[mxConstants.STYLE_RESIZABLE] = 0;
    style[mxConstants.STYLE_ASPECT] = 'fixed';
    return style;
  }

  public onAddedToGraph(graph: HCLTreeMxGraph) {
    this.setGraph(graph);
  }

  getType(): string {
    return null;
  }
}

export default FunctionalEventPort;
